/**
 *判断机型
 *
 */
export const isIos = () => {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  return isiOS ? 'ios' : 'android'
}



/**
 *剩余时间
 *endTime :String '2020-02-20 00:00:00'
 *offset  :String 时间偏移量 单位毫秒
 *servertime  :String 服务器时间戳 单位毫秒
 */

export const getTimeLeft = (endtime, offset, servertime) => {
  endtime = endtime.replace(new RegExp('-', 'g'), '/')
  var leftTime = new Date(endtime + '+00').getTime() + offset * 1000 - servertime * 1000;
  return endTime(leftTime)
}


/**
 *leftTime :String 当前时间戳
 */
function endTime(leftTime) {
  var time, d, h, m, s
  if (leftTime >= 0) {
    d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
    h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
    m = Math.floor((leftTime / 1000 / 60) % 60);
    s = Math.floor((leftTime / 1000) % 60);
    if (h < 10) {
      h = "0" + h;
    }
    if (m < 10) {
      m = "0" + m;
    }
    if (s < 10) {
      s = "0" + s;
    }
    if (d >= 1) {
      time = `${d}Day(s) ${h}:${m}:${s} `;
    } else {
      time = `${h}:${m}:${s} `;
    }
    // timer = setInterval(endTime(leftTime), 1000)
    // timer = setTimeout(endTime(leftTime), 1000);
    // leftTime = leftTime - 1000;
  } else {
    // timer && clearInterval(timer);
    d = 0
    h = 0
    m = 0
    s = 0
    time = "00:00:00";
  }
  // console.log(time);
  // return time
  return {
    d: d,
    h: h,
    m: m,
    s: s,
    time: time
  }
}


/**
 *异步加载js
 *url :String
 *callback : function
 */
export const loadJS = (url, callback) => {
  var script = document.createElement('script'),
    fn = callback || function () {};
  script.type = 'text/javascript';
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null;
        fn();
      }
    };
  } else {
    script.onload = function () {
      fn();
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}



/**
 *base64加密
 *str  :String
 */
export const b64EncodeUnicode = (str) => {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}


/**
 *base64解密
 *str  :String
 */
export const b64DecodeUnicode = (str) => {
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}


/**
 * 格式化时间样式
 * YYYY  :年
 * MM  :月
 * DD  :日
 * HH  :时
 * mm  :分
 * ss  :秒
 */
export const formatTime = (YYYY, MM, DD, HH, mm, ss) => {
  MM = MM > 9 ? MM : ('0' + MM)
  DD = DD > 9 ? DD : ('0' + DD)
  HH = HH > 9 ? HH : ('0' + HH)
  mm = mm > 9 ? mm : ('0' + mm)
  ss = ss > 9 ? ss : ('0' + ss)
  return `${YYYY}-${MM}-${DD} ${HH}:${mm}:${ss}`
}



/**
 * 时间戳格式化成本地时间
 * t  :时间戳 单位要是毫秒
 */
export const formatClientTime = (t, server_time_offset = 0) => {
  var dt
  if (t.length <= 10 && server_time_offset.length <= 10) {
    dt = new Date(t + server_time_offset)
  } else if (t.length <= 10) {
    dt = new Date(t * 1000 + server_time_offset)
  } else if (server_time_offset.length <= 10) {
    dt = new Date(t + server_time_offset * 1000)
  } else {
    dt = new Date(t + server_time_offset)
  }
  return formatTime(dt.getFullYear(), dt.getMonth() + 1, dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds())
}


/**
 * 时间戳格式化成utc时间
 * t  :时间戳
 * server_time_offset  :时间偏移量 单位要是毫秒
 */
export const formatServerTime = (t, server_time_offset = 0) => {
  const dt = new Date(t + server_time_offset)
  return formatTime(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate(), dt.getUTCHours(), dt.getUTCMinutes(), dt.getUTCSeconds())
}



/**
 * 设置cookie
 * name  :键
 * value  :值
 * Days  :时间
 */
export const setCookie = (name, value, Days = 30) => {
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

/**
 * 获取cookie
 * name  :键
 */
export const getCookie = (name) => {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
}


/**
 * 删除cookie
 * name  :键
 */
export const delCookie = (name) => {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}



/**
 * 判断浏览器
 */
export const versions = () => {
  var u = navigator.userAgent,
    app = navigator.appVersion;
  return {
    trident: u.indexOf('Trident') > -1, //IE内核
    isOpera: u.indexOf('Presto') > -1, //opera内核
    isChrome: u.indexOf("Chrome") > -1 && u.indexOf("Safari") > -1 && u.indexOf('Trident') <= -1, //苹果、谷歌内核
    isFF: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    isSafari: u.indexOf("Safari") > -1 && u.indexOf("Chrome") == -1, //判断是否Safari浏览器
    isVivo: u.indexOf("VivoBrowser") > -1, //判断vivo浏览器
    isOppo: u.indexOf("HeyTapBrowser") > -1, //判断Oppo浏览器
    isMiui: u.indexOf("MiuiBrowser") > -1, //判断miui浏览器
  }
}


/**
 * 获取参数
 */
export const getParam = () => {
  let linkInfo = {};
  const p = decodeURI(window.location.href).split("?")[1];
  if (p) {
    const arr = p.split("&");
    if (arr.length > 1) {
      arr.map((item) => {
        linkInfo[item.split("=")[0]] = item.split("=")[1];
      });
    } else {
      let locaitonSearch = window.location.search.split("?")[1] || "";
      if (locaitonSearch) {
        try {
          if (locaitonSearch.indexOf("&fb") > 0) {
            locaitonSearch = locaitonSearch.split("&fb")[0];
          }
          locaitonSearch = locaitonSearch.replace(/%3D/g, "=");
          const x = b64DecodeUnicode(locaitonSearch);
          const arry = x.split("&");
          for (let i = 0; i < arry.length; i++) {
            linkInfo[arry[i].split("=")[0]] = arry[i].split("=")[1];
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
  return linkInfo;
}


/**
 * 去除参数
 */
export const clearParams = () => {
  try {
    history.pushState(null, null, window.location.href.split("?")[0]);
  } catch (error) {
    window.location.href = window.location.href.split("?")[0];
  }
}
